import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

const Wrapper = styled.div`
  background-color: ${tokens.BRAND_COLORS.neutral_800};
  border-radius: ${tokens.radius.l};
  border: 1px solid ${tokens.color.white};
  padding: 0 3px;
  color: ${tokens.color.text_default_inverse};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  min-width: 22px;
  ${tokens.text('caption')}
  ${tokens.elevation(1)};
`;

interface OverflowProps {
  className?: string;
  number: number;
  maxDigits?: number;
}

export function Overflow({ className, number, maxDigits = 5 }: OverflowProps): JSX.Element {
  const finalMaxDigits = Math.max(1, maxDigits);
  const finalNumber = Math.min(number, 10 ** finalMaxDigits - 1);

  return <Wrapper className={className}>+{finalNumber}</Wrapper>;
}
